import { Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { CategoryFilterTreeItem } from '../../../../../../Model/Catalog/exportFilter/categoryFilterTreeItem';
import { FeatureSystemFilter } from '../../../../../../Model/Dto/FeatureSystemFilter';
import { TreeItem } from '../../../../../../Model/Dto/TreeItem';
import { CatalogFilter } from '../../../../../../Model/exportParameter/CatalogFilter';
import { ExportParameter } from '../../../../../../Model/exportParameter/ExportParameter';
import { SimpleHierachicalFilter } from '../../../../../../Model/exportParameter/SimpleHierachicalFilter';
import { ExportFilterService } from '../../../../../../Services/exportFilter.service';
import { ModelService } from '../../../../../../Services/model.service';

@Component({
  selector: 'mime-content-filter',
  templateUrl: './mime-content-filter.component.html'
})
export class MimeContentFilterComponent implements OnInit {
  @ViewChild("treeViewMimeSelectFilter", { static: false }) treeViewMimeSelectFilter: DxTreeViewComponent;
  @Input() exportParameter: ExportParameter;
  @Input() catalogId: string;
  @Input() customerId: string;

  mimeSelectFilters: { description: string }[] = [];
  isFilterLoaded: boolean = false;

  constructor(public modelService: ModelService, public exportFilterService: ExportFilterService) {
    this.refreshMimeSelectFilter = this.refreshMimeSelectFilter.bind(this);
  }

  ngOnInit(): void {
    if (this.exportParameter.mimeContentFilter == null)
      this.exportParameter.mimeContentFilter = new CatalogFilter<string[]>([]);
    if (this.exportParameter.mimeContentFilter.filterKey == null)
      this.exportParameter.mimeContentFilter.filterKey = [];

    this.refreshMimeSelectFilter();
  }

  refreshMimeSelectFilter() {
    if (!this.exportParameter.mimeContentFilter.useFilter)
      return;

    this.isFilterLoaded = false;
    this.exportFilterService.getMimeFilterTreeElements(this.catalogId, this.customerId)
      .subscribe((filter: string[]) => {
        this.mimeSelectFilters = filter.map(description => ({ description }));
        this.isFilterLoaded = true;
      });
  }
}
